import React from 'react';

import { IPrimaryHero } from '../../../../interfaces/hero';

import './PrimaryHero.scss';

const PrimaryHero = ({ title, color, bottomContent }: IPrimaryHero) => (
  <>
    <div className={`main-hero primary-hero ${color}`}>
      <div className="content">
        <div className="title">{title}</div>
        {bottomContent && <div className="bottom-content">{bottomContent}</div>}
      </div>
    </div>
    <div className="primary-hero-spacer" />
  </>
);

export default PrimaryHero;
